import React, { useState, useEffect } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import { CircularProgress, TextField } from "@material-ui/core";
import Modal from "../modals/Modal";
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  MenuItem,
  FormControl,
  Select
} from "@material-ui/core";
import { Delete, RefreshRounded } from "@material-ui/icons";
import ModalMessage from "../modals/ModalMessage";

// styles
import useStyles from "../products/styles";
import useStylesTable from "../products/styles";
import config from "../../config";

export default function OtherSales() {
  const classes = useStyles();
  const classesTable = useStylesTable();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [total, setTotal] = useState(null);
  const [turn, setTurn] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [keyButton, setKeyButton] = useState(1);
  const [allProducts, setAllProducts] = useState([]);
  const allTurns = [
    {
      "name": "Matutino",
      "value": 1,
    },
    {
      "name": "Vespertino",
      "value": 2,
    },
    {
      "name": "Medio día",
      "value": 3,
    },
  ];
  const [products, setProducts] = useState([]);
  const [autocompleteKey, setAutocompleteKey] = useState(0);
  const [showModalMessage, setShowModalMessage] = useState(false);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const closeModalMessage = e => {
    setShowModalMessage(false);
  }

  const fechGetProducts = async () => {
    fetch(baseUrl + "onlyProducts",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data.error != null) {
          setShowModal(true);
        } else {
          setAllProducts(data);
        }
      })
      .catch(error => null);
  }

  useEffect(() => {
    fechGetProducts();
  }, []);

  const onTagsChange = (event, values) => {
    if (values != null) {
      var product = {
        "id": values.id,
        "name": values.name,
        "price": values.price,
        "amount": Number(values.price),
        "quantity": 1,
      };

      if (products.length > 0) {
        var existProduct = false;

        products.map((item) => {
          if (item.id == product.id && item.type == product.type) {
            existProduct = true;
          }
        });

        if (existProduct) {
          setShowModalMessage(true);
        } else {
          const allList = products;
          allList.push(product);
          setProducts(allList);
        }
      } else {
        const allList = products;
        allList.push(product);
        setProducts(allList);
      }
    }

    setAutocompleteKey(autocompleteKey + 1);
    calculateTotal();
  }

  const onDelete = (property) => (event) => {
    var indexProduct = -1;

    products.map((item) => {
      if (item.id == property) {
        indexProduct = products.indexOf(item);
      }
    });

    if (indexProduct > -1) {
      var list = products;
      if (list.length == 1) {
        setProducts([]);
        setTotal(0);
      } else {
        delete list[indexProduct];
        setProducts(list);

        var value = 0;
        list.map((item) => {
          value = Number(value) + Number(item.amount);
        });

        setTotal(value);
      }

      setKeyButton(keyButton + 1);
    }
  };

  const handleQuantity = (id, event) => {
    var value = event.target.value;
    var indexProduct = 0;
    var product = null;

    products.map((item) => {
      if (item.id == id) {
        indexProduct = products.indexOf(item);
        product = {
          "id": item.id,
          "name": item.name,
          "price": item.price,
          "amount": Number(item.price) * Number(value),
          "quantity": value,
        };
      }
    });

    if (product != null) {
      const allList = products;
      allList[indexProduct] = product;
      setProducts(allList);
      setKeyButton(keyButton + 1);
    }

    calculateTotal();
  }

  const onSave = async e => {
    e.preventDefault();
    setIsLoading(true);
    var otherSaleList = [];

    products.map((item) => {
      var product = {
        "idProduct": item.id,
        "price": item.price,
        "amount": item.amount,
        "quantity": item.quantity
      };

      otherSaleList.push(product);
    });

    const newSale = {
      idUser: localStorage.getItem("idUserSystem"), total: total, otherSaleProductList: otherSaleList, turn: turn
    };

    const response = await fetch(baseUrl + "createOtherSale", {
      method: 'POST',
      headers: {
        'Accept': 'application/json', 'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("token")
      },
      body: JSON.stringify(newSale)
    });

    const json = await response.json();
    if (json.message == "Ok") {
      setProducts([]);
      setTotal(null);
      setKeyButton(keyButton + 1);
    } else {
      if (json.message == "Access is denied") {
        setShowModal(true);
      }
    }

    setIsLoading(false);
  }

  function calculateTotal() {
    var value = 0;
    products.map((item) => {
      value = Number(value) + Number(item.amount);
    });

    setTotal(value);
  }

  const handleChange = (e) => {
    const value = e.target.value;
    setTurn(value);
    setKeyButton(keyButton + 1);
  }

  return (
    <>
      <Modal
        isOpen={showModal}
        closeModal={closeModalLogin}
      />

      <ModalMessage
        isOpen={showModalMessage}
        closeModal={closeModalMessage}
      />

      <div className={classes.divTitle}>
        <PageTitle title="Otras ventas" />
      </div>

      <div>
        <div style={{ marginBottom: '30px', width: '40%' }}>
          <div className={classes.divLabel}>
            <p className={classes.label} >Turno</p>
          </div>
          <FormControl className={classes.formControl}>
            <Select
              onChange={handleChange}
              displayEmpty
              style={{ color: "#FFFFFF" }}
            >
              <MenuItem value=""> Selecciona </MenuItem>
              {allTurns.map((option) => (
                <MenuItem value={option.value}>{option.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <div className={classes.divHeader} >
          <div className={classes.searchDivFullWidthWithoutShadow} >
            <Autocomplete
              key={autocompleteKey}
              options={allProducts}
              getOptionLabel={option => option.name}
              onChange={onTagsChange}
              className={classes.inputSearchFull}
              openText={"Abrir"}
              closeText={"Cerrar"}
              clearText={"Limpiar"}
              noOptionsText={"Sin resultados"}
              renderInput={params => (
                <TextField
                  {...params}
                  variant="standard"
                  placeholder={"Buscar producto"}
                  fullWidth
                />
              )}
            />
          </div>
          <div className={classesTable.divActionButton}>
            <RefreshRounded className={classesTable.iconAcctionInventory}
              onClick={fechGetProducts}
            />
          </div>
        </div>

        <div style={{ marginTop: "60px" }}></div>
        <div className={classesTable.divCard} >
          <Table className="mb-0">
            <TableHead>
              <TableRow className={classesTable.root} >
                <TableCell>NOMBRE</TableCell>
                <TableCell>PRECIO</TableCell>
                <TableCell>CANTIDAD</TableCell>
                <TableCell>IMPORTE</TableCell>
                <TableCell>ACCIÓN</TableCell>
                {/*{keys.map(key => (
                  <TableCell key={key}>{key}</TableCell>
                ))}*/}
              </TableRow>
            </TableHead>
            <TableBody>
              {products.map(({ id, name, price, amount, quantity, }) => (
                <TableRow key={id}>
                  <TableCell className={classesTable.tableTextStyle} >{name}</TableCell>
                  <TableCell className={classesTable.tableTextStyle} >{"$ " + parseFloat(price).toFixed(2)}</TableCell>
                  <TableCell className={classesTable.tableTextStyle} >
                    <div style={{ width: "120px" }}>
                      <TextField
                        InputProps={{
                          classes: {
                            focused: classes.textBorder,
                            input: classes.inputForm,
                          },
                          inputProps: {
                            min: 1
                          }
                        }}
                        type={"number"}
                        onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                        value={quantity}
                        onChange={(event) => handleQuantity(id, event)}
                        name={"quantity"}
                      />
                    </div>
                  </TableCell>
                  <TableCell className={classesTable.tableTextStyle} >{"$ " + parseFloat(amount).toFixed(2)}</TableCell>
                  <TableCell className={classesTable.tableTextStyle} >
                    <div>
                      <div className={classesTable.divActionButton}>
                        <Delete className={classesTable.iconAcctionInventory}
                          onClick={onDelete(id)}
                        />
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        {total == null || total == 0 ? (
          <div style={{ display: "flex", float: "right", marginBottom: "80px" }} >
            <p className={classes.labelTitle} >{"Total: $ 0"}</p>
          </div>
        ) : (
          <div style={{ display: "flex", float: "right", marginBottom: "80px" }} >
            <p className={classes.labelTitle} >{"Total: $ " + total}</p>
          </div>
        )}

        <div style={{ marginTop: "60px" }}>

          <div className={classes.divButton}>
            {isLoading ? (
              <div className={classes.loginLoader} >
                <CircularProgress size={26} />
              </div>
            ) : (
              <button
                key={keyButton}
                className={products.length > 0 && turn != '' ?
                  classes.enableButton : classes.disableButton}
                disabled={!(products.length > 0 && turn != '')}
                onClick={onSave}
              >GUARDAR</button>
            )}
          </div>
        </div>

      </div>
    </>
  );
}
